import { defineMessages } from 'react-intl';

const CartPageMessages = defineMessages({
    cartPageCartTitle: {
        id: 'cartPage.cartPageMessages.cartPageCartTitle',
        description: 'Cart title',
        defaultMessage: 'Cart'
    },
    cartPageToTitle: {
        id: 'cartPage.cartPageMessages.cartPageToTitle',
        description: 'To title',
        defaultMessage: 'To:'
    },
    cartPageYouTitle: {
        id: 'cartPage.cartPageMessages.cartPageYouTitle',
        description: 'You title',
        defaultMessage: 'You'
    },
    giftCardsCountTitle: {
        id: 'cartPage.cartPageMessages.GiftCardsTitle',
        description: 'Title for Quantity of cards',
        defaultMessage: '({count} {count, plural, one {gift card} other {gift cards}})'
    },
    digitalGiftCardsTitle: {
        id: 'cartPage.cartPageMessages.DigitalGiftCardsTitle',
        description: 'Title for Digital Gift Cards',
        defaultMessage: 'Digital'
    },
    printAtHomeCardsTitle: {
        id: 'cartPage.cartPageMessages.PrintAtHomeCardsTitle',
        description: 'Title for PrintAtHomeCards',
        defaultMessage: 'Print at home'
    },
    PhysicalGiftCardsTitle: {
        id: 'cartPage.cartPageMessages.PhysicalGiftCardsTitle',
        description: 'Title for Physical GiftCards',
        defaultMessage: 'Physical'
    },
    editButtonText: {
        id: 'cartPage.cartPageMessages.editButtonText',
        description: 'Edit button label',
        defaultMessage: 'Edit'
    },
    editButtonAriaText: {
        id: 'cartPage.cartPageMessages.editButtonAriaText',
        description: 'Edit button label',
        defaultMessage: 'Edit cart item'
    },
    removeButtonText: {
        id: 'cartPage.cartPageMessages.removeButtonText',
        description: 'Remove button label',
        defaultMessage: 'Remove'
    },
    removeButtonArialText: {
        id: 'cartPage.cartPageMessages.removeButtonArialText',
        description: 'Remove button label',
        defaultMessage: 'Remove cart item'
    },
    addAnotherCardButtonText: {
        id: 'cartPage.cartPageMessages.addAnotherCardButtonText',
        description: 'Add another card button label',
        defaultMessage: 'Add Another Card'
    },
    continueShoppingButtonText: {
        id: 'cartPage.cartPageMessages.continueShoppingButtonText',
        description: 'Add another card button label',
        defaultMessage: 'Continue Shopping'
    },
    recipientNameLabel: {
        id: 'cartPage.cartPageMessages.recipientNameLabel',
        description: 'Recipient name label',
        defaultMessage: 'Recipient Name'
    },
    recipientEmailLabel: {
        id: 'cartPage.cartPageMessages.recipientEmailLabel',
        description: 'Recipient email label',
        defaultMessage: 'Recipient Email'
    },
    purchaseValueText: {
        id: 'cartPage.cartPageMessages.purchaseValueText',
        description: 'Label for the gift card purchase value',
        defaultMessage: '{value} gift card x {quantity}'
    },
    promoPurchaseValueLabel: {
        id: 'cartPage.cartPageMessages.promoPurchaseValueLabel',
        description: 'Label for the gift card purchase value',
        defaultMessage: 'Value: {value} '
    },
    promoPurchaseValueText: {
        id: 'cartPage.cartPageMessages.promoPurchaseValueText',
        description: 'Text for the gift card purchase value',
        defaultMessage: '{label} x {quantity}'
    },
    promoGiftCardText: {
        id: 'cartPage.cartPageMessages.promoGiftCardText',
        description: 'Label for the gift card purchase value',
        defaultMessage: 'gift card'
    },
    totalValueText: {
        id: 'cartPage.cartPageMessages.totalValueText',
        description: 'Total value label for the gift cards',
        defaultMessage: 'Total: {totalValue}'
    },
    removedCardText: {
        id: 'cartPage.cartPageMessages.removedCardText',
        description: 'Text displayed when a card is removed',
        defaultMessage: 'Removed'
    },
    undoButtonText: {
        id: 'cartPage.cartPageMessages.undoButtonText',
        description: 'Text on the undo button',
        defaultMessage: 'Undo'
    },
    changeRecipientButtonText: {
        id: 'cartPage.cartPageMessages.changeRecipientButtonText',
        description: 'Button text for changing recipient',
        defaultMessage: 'Change Recipient'
    },
    changeRecipientConfirmButtonText: {
        id: 'cartPage.cartPageMessages.changeRecipientConfirmButtonText',
        description: 'Button text for changing recipient',
        defaultMessage: 'Confirm'
    },
    proceedToCheckoutText: {
        id: 'cartPage.cartPageMessages.proceedToCheckoutText',
        description: 'Text for the proceed to checkout button',
        defaultMessage: 'Proceed to checkout • {price}'
    },
    offerSectionHeader: {
        id: 'cartPage.cartPageMessages.offerSectionHeader',
        description: 'Header for the offer section in the cart page',
        defaultMessage: 'Offers and promo code'
    },
    orderTotalDiscount: {
        id: 'cartPage.cartPageMessages.orderTotalDiscount',
        description: 'Discount label in order summary',
        defaultMessage: 'Discount'
    },
    offerAutoApplied: {
        id: 'cartPage.cartPageMessages.offerAutoApplied',
        description: 'Text indicating that an offer is auto-applied',
        defaultMessage: 'Offer auto-applied'
    },
    freeLabel: {
        id: 'cartPage.cartPageMessages.freeLabel',
        description: 'Label indicating a free offer',
        defaultMessage: 'FREE'
    },
    giftCardSubtotal: {
        id: 'cartPage.cartPageMessages.giftCardSubtotal',
        description: 'Gift card subtotal label',
        defaultMessage: 'Gift card subtotal'
    },
    fedexDelivery: {
        id: 'cartPage.cartPageMessages.fedexDelivery',
        description: 'FedEx 2 Day Delivery label',
        defaultMessage: 'FedEx 2 Day Delivery'
    },
    upsDelivery: {
        id: 'cartPage.cartPageMessages.upsDelivery',
        description: 'UPS 7 Day Delivery label',
        defaultMessage: 'UPS 7 Day Delivery'
    },
    purchaseFee: {
        id: 'cartPage.cartPageMessages.purchaseFee',
        description: 'Purchase fee label',
        defaultMessage: 'Purchase fee × {quantity}'
    },
    physicalactivationFee: {
        id: 'cartPage.cartPageMessages.physicalactivationFee',
        description: 'Physical card handling fee label',
        defaultMessage: 'Physical card handling fee {hasAmount, select, true { ({amount})} false {}} × {quantity}'
    },
    physicalDisplayName: {
        id: 'cartPage.cartPageMessages.physicalDisplayName',
        description: 'display Name label',
        defaultMessage: '{displayName} × {quantity}'
    },
    physicalFreeDisplayName: {
        id: 'cartPage.cartPageMessages.physicalFreeDisplayName',
        description: 'display free Name label',
        defaultMessage: '{displayName} × {quantity}'
    },
    orderTotalAccessories: {
        id: 'cartPage.cartPageMessages.orderTotalAccessories',
        description: 'Accessory label',
        defaultMessage: 'Accessory × {quantity}'
    },
    giftBoxExtras: {
        id: 'cartPage.cartPageMessages.giftBoxExtras',
        description: 'Accessory summary label',
        defaultMessage: 'Accessory ({amount}) × {quantity}'
    },
    orderSummaryHeaderText: {
        id: 'cartPage.cartPageMessages.orderSummaryText',
        description: 'Order Summary Header',
        defaultMessage: 'Your order ({count} {count, plural, one {gift card} other {gift cards}})'
    },
    orderSummaryCurrencyText: {
        id: 'cartPage.cartPageMessages.orderSummaryCurrencyText',
        description: 'Order Summary currency',
        defaultMessage: '(in { currency })'
    },
    orderSummaryTotalText: {
        id: 'cartPage.cartPageMessages.orderSummaryTotalText',
        description: 'Order Summary total',
        defaultMessage: 'Total'
    },
    promoNudgeText: {
        id: 'cartPage.cartPageMessages.promoNudgeText',
        description: 'Promo Nudge description',
        defaultMessage: 'Add {value} to Sandra gift card to get free shipping'
    },
    promoNudgeButtonText: {
        id: 'cartPage.cartPageMessages.promoNudgeButtonText',
        description: 'Promo add button',
        defaultMessage: 'Add {value}'
    },
    gotItButtonText: {
        id: 'cartPage.cartPageMessages.gotItButtonText',
        description: 'Got it button text',
        defaultMessage: 'Got it'
    },
    toolTipPopUpMessage: {
        id: 'cartPage.cartPageMessages.toolTipPopUpMessage',
        description: 'Tool Tip PopUp message',
        defaultMessage: 'After purchase you’ll receive a gift card link to share with the recipient.'
    },
    shareViaLinkText: {
        id: 'cartPage.cartPageMessages.shareViaLinkText',
        description: 'Share Via Link text',
        defaultMessage: 'You’ll share a link'
    },
    termsAndConditionsText: {
        id: 'cartPage.cartPageMessages.termsAndConditionsText',
        description: 'Term And Conditions label',
        defaultMessage: 'Terms of Offer'
    },
    virtualFreeItemLabel: {
        id: 'cartPage.cartPageMessages.virtualFreeItemLabel',
        description: 'Virtual Free Item Label',
        defaultMessage: 'Virtual item'
    },
    promoItemLabel: {
        id: 'cartPage.cartPageMessages.promoItemLabel',
        description: 'Label for Promo items in OfferSection and OrderSummary section',
        defaultMessage: '{label} x {quantity}'
    },
    emptyCartTitle: {
        id: 'cartPage.cartPageMessages.emptyCartTitle',
        description: 'Empty card Title',
        defaultMessage: 'Your cart is currently empty'
    },
    deliveryItemTitle: {
        id: 'cartPage.cartPageMessages.deliveryItemTitle',
        description: 'Delivery title',
        defaultMessage: 'Delivery:'
    },
    orderPromoSummaryItemText: {
        id: 'cartPage.cartPageMessages.orderPromoSummaryItemText',
        description: 'Promo Summary Item title',
        defaultMessage: 'bonus card'
    },
    SelectedFaceplateText: {
        id: 'cartPage.cartPageMessages.SelectedFaceplateText',
        description: 'Selected Faceplate Text',
        defaultMessage: 'Selected Faceplate'
    },
    cartAtMax: {
        id: 'cart.cartMessages.cartAtMax',
        description: 'Warning message displayed when the total value of the cart is at '
            + 'the maximum allowed value of a single purchase',
        defaultMessage: `Your current cart of {total} `
            + `is at the maximum allowed order amount. `
            + `You may not add additional items.`
    },
    addCardAtLimitWarning: {
        id: 'cart.cartMessages.addCardAtLimitWarning',
        description: 'Warning message displayed when a user tries to start adding a new item to the cart '
            + 'when the number of line items in the cart is at the limit',
        defaultMessage: 'You have reached the limit of {limit} unique items in your cart. '
            + 'You may not add additional items.'
    },
    addCardExceedsLimitError: {
        id: 'cart.cartMessages.addCardExceedsLimitError',
        description: 'Warning message displayed when a user tries to start adding a new item to the cart '
            + 'when the number of line items in the cart has already exceeded the limit',
        defaultMessage: 'You have exceeded the limit of {limit} unique items in your cart. '
            + 'Please remove {excess} {excess, plural, one {item} other {items}} to proceed.'
    },
    cartMultipleCurrency: {
        id: 'cart.cartMessages.cartMultipleCurrency',
        description: 'Error message displayed when the cart contains items with different currency codes',
        defaultMessage: `Looks like the cards in your cart have multiple currencies ({currencyCodes}). `
        + `Please remove cards until your cart contains only cards with one type of currency.`
    },
    cartOverMax: {
        id: 'cart.cartMessages.cartOverMax',
        description: 'Error message displayed when the total value of the cart exceeds '
            + 'the maximum allowed value of a single purchase',
        defaultMessage: `Your current cart of {total} `
            + `exceeds the maximum allowed order amount of {max}`
    },
    shippingSubTotal: {
        id: 'cart.cartMessages.shippingSubTotal',
        description: 'Shipping total fee for the physical card',
        defaultMessage: 'Shipping Subtotal'
    },
    plcmt_promo_text: {
        id: 'cart.cartMessages.plcmt_promo_text',
        description: 'plcmt promo text',
        defaultMessage: 'Free gift card code shipped with the qualifying purchase.'
    },
    allowedPhysicalCardExceedsLimitError: {
        id: 'cart.cartMessages.allowedPhysicalCardExceedsLimitError',
        description: 'Warning message displayed when a user tries to start adding a new physical card to the cart '
            + 'when the number of physical cards in the cart has already exceeded the limit',
        defaultMessage: 'You have exceeded the limit of {limit} physical cards in your cart. '
            + 'Please remove {excess} {excess, plural, one {item} other {items}} to proceed.'
    },
    shippingExtras: {
        id: 'cart.cartMessages.shippingExtras',
        description: 'shippingExtras heading label',
        defaultMessage: 'Shipping & extras'
    },
    cartSummaryText: {
        id: 'cartPage.cartPageMessages.cartIconText',
        description: 'Cart summary with total cards count and item text',
        defaultMessage: 'Cart: {count} {count, plural, one {item} other {items}}'
    },
    cartPromoTitle: {
        id: 'cartPage.cartPageMessages.cartPromoTitle',
        description: 'Cart text for the cart promo title',
        defaultMessage: 'Enter promo code'
    },
    applyPromoButton: {
        id: 'cartPage.cartPageMessages.applyPromoButton',
        description: 'Cart text for the cart promo apply button',
        defaultMessage: 'Apply'
    },
    cpfLabel: {
        id: 'cart.cartMessages.cpf.title',
        description: 'cpf number field on the cart page',
        defaultMessage: 'CPF number'
    },
    cpfNumberEmpty: {
        id: 'cart.cartMessages.cpf.cpfNumberEmpty',
        description: 'Error message displayed when a CPF number is not provided',
        defaultMessage: 'CPF Number is Empty.'
    },
    cpfNumberInvalid: {
        id: 'cart.cartMessages.cpf.cpfNumberInvalid',
        description: 'Error message displayed when a CPF number is not provided',
        defaultMessage: 'CPF Number is Invalid.'
    },
    congratulationsQualified: {
        id: 'cartPage.cartPageMessages.congratulationsQualified',
        description: 'Congratulations message when user qualifies for shipping promo',
        defaultMessage: 'Congratulations! You qualified.'
    },
    freeShipping: {
        id: 'cartPage.cartPageMessages.freeShipping',
        description: 'Free shipping label',
        defaultMessage: 'Free Shipping'
    },
    discountedShipping: {
        id: 'cartPage.cartPageMessages.discountedShipping',
        description: 'Discounted shipping label with amount off',
        defaultMessage: 'Discounted Shipping - {amount} off'
    },
    discountLabel: {
        id: 'cartPage.cartPageMessages.discountLabel',
        description: 'Label for discount amount',
        defaultMessage: '{amount} discount'
    }
});

export default CartPageMessages;
